// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3q7JK","tab":"Tabs_tab__aJmvu","tabActive":"Tabs_tabActive__2jbQq"};